import { FC } from 'react';
import { Datepicker } from '@ibsys/kit';
import { useTranslation } from 'react-i18next';
import type { BillingDateRange } from '@/entities/billing';

type Props = {
  value: BillingDateRange;
  onChange: (next: BillingDateRange) => void;
};

/**
 * Фильтр диапазона дат для страницы биллинга. Состоит из двух полей `Datepicker`
 * (от / до), оба возвращают значения в формате `YYYY-MM-DD` (`outputType="iso-date"`),
 * что позволяет напрямую сравнивать со строковым полем `dailyUsage[].date`.
 */
export const BillingDateFilter: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation('billing');

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Datepicker
        label={t('filter.from')}
        value={value.from}
        outputType="iso-date"
        onChange={(next) => onChange({ ...value, from: typeof next === 'string' ? next : '' })}
      />
      <Datepicker
        label={t('filter.to')}
        value={value.to}
        outputType="iso-date"
        onChange={(next) => onChange({ ...value, to: typeof next === 'string' ? next : '' })}
      />
    </div>
  );
};
